export const shortcut = []
export const items = [
  {
    'title': 'Finans',
    'router': 'Finans',
    'icon': 'fa-money',
    'param': null,
    'sub': [
      {
        'title': 'Nakit İşlemler',
        'router': null,
        'icon': null,
        'param': null,
        'sub': [
          {
            'title': 'alt 1',
            'router': null,
            'icon': null,
            'param': null,
            'sub': null
          },
          {
            'title': 'alt 2',
            'router': null,
            'icon': null,
            'param': null,
            'sub': null
          },
          {
            'title': 'alt 3',
            'router': null,
            'icon': null,
            'param': null,
            'sub': null
          },
          {
            'title': 'alt 4',
            'router': null,
            'icon': null,
            'param': null,
            'sub': null
          },
          {
            'title': 'alt 5',
            'router': 'PriceList',
            'icon': null,
            'param': null,
            'sub': null
          },
          {
            'title': 'alt 6',
            'router': null,
            'icon': null,
            'param': null,
            'sub': null
          },
          {
            'title': 'alt 7',
            'router': null,
            'icon': null,
            'param': null,
            'sub': null
          },
          {
            'title': 'alt 8',
            'router': null,
            'icon': null,
            'param': null,
            'sub': null
          }
        ]
      },
      {
        'title': 'Kredi Kartı',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Havale/Eft',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Çek İşlemleri',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Fiyat Listesi',
        'router': 'PriceList',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Borç Düzenleme',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Cari Hesap Hareketleri',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Prim Talebi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Indirim/Kampanya Tanimlari',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Senet İşlemleri',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Prim Sonucu',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Prim Onay Listesi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  },
  {
    'title': 'Ana Kayıtlar',
    'router': 'Ana Kayıtlar',
    'icon': 'fa-university',
    'param': null,
    'sub': [
      {
        'title': 'Personel',
        'router': 'Employee',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Banka',
        'router': 'Bank',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Birim Seti',
        'router': 'UnitSet',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Şube Ana Kayıtları',
        'router': 'Branch',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Ürün Ana Kayıtları',
        'router': 'Item',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Müşteri Kayıtları',
        'router': 'Customer',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Depo Ana Kayıtları',
        'router': 'Warehouse',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Araç Ana Kayıtları',
        'router': 'Vehicle',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Rota Ana Kayıtları',
        'router': 'Route',
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  },
  {
    'title': 'Stok',
    'router': 'Stok',
    'icon': 'fa-archive',
    'param': null,
    'sub': [
      {
        'title': 'Depo Stok',
        'router': 'WarehouseStock',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Depo Stok Tarihçesi',
        'router': 'WarehouseStockHistory',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Stok Transferi',
        'router': 'BranchStockTransfer',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Stok Hareketi Görüntüleme',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Stok Düzenleme',
        'router': 'StockAdjustment',
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  },
  {
    'title': 'Muhasebe',
    'router': 'Muhasebe',
    'icon': 'fa-pencil-square-o',
    'param': null,
    'sub': [
      {
        'title': 'Banka Muhasebe Eşleştirme',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Genel Muhasebe Eşleştirme',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Malzeme Hesap Bilgileri',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Fatura Genel Hesabı',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Muhasebe Fişi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Hesap Kodu Tanımlama',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  },
  {
    'title': 'İade',
    'router': 'İade',
    'icon': 'fa-retweet',
    'param': null,
    'sub': [
      {
        'title': 'Satış İade Talebi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Satış İade İrsaliyesi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Satış İade Faturası',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Alım İade İrsaliyesi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Alım İade Faturası',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Tartım Bilgileri',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Alım İade Talebi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  },
  {
    'title': 'Satış / Satın Alma',
    'router': 'Satış / Satın Alma',
    'icon': 'fa-shopping-basket',
    'param': null,
    'sub': [
      {
        'title': 'Satın Alma Faturası',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Satın Alma Siparişi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Satış Faturası',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Teslimat İrsaliyesi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Mal Kabul İrsaliyesi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Satış Siparişi',
        'router': 'Order',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Hizmet Satış Faturası',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  },
  {
    'title': 'Servis',
    'router': 'Servis',
    'icon': 'fa-wrench',
    'param': null,
    'sub': [
      {
        'title': 'Arıza Takip Formu',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Günlük Performans Takibi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Servis Kayıtları',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Sistem',
        'router': null,
        'icon': 'fa-system',
        'param': null,
        'sub': null
      },
      {
        'title': 'Aktivite Noktası Analiz Sonuçları',
        'router': 'FieldAnalysisResult',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Ürün Analizi Sonuçları',
        'router': 'ItemAnalysisResult',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Saha Araştırması Sonuçları',
        'router': 'FieldSurveyResult',
        'icon': null,
        'param': null,
        'sub': null
      },
      {
        'title': 'Saha Araştırması Tanımları',
        'router': 'FieldSurvey',
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  },
  {
    'title': 'Sistem',
    'router': 'Sistem',
    'icon': 'fa-system',
    'param': null,
    'sub': [
      {
        'title': 'E-Belge Hata Yönetimi',
        'router': null,
        'icon': null,
        'param': null,
        'sub': null
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/nav.js